module.exports = __webpack_public_path__ + "img/concept-idea-innovation-212286.41197039.jpg";